const translation = {
  currentPlan: 'Поточний план',
  upgradeBtn: {
    plain: 'Оновити план',
    encourage: 'Оновити зараз',
    encourageShort: 'Оновити',
  },
  viewBilling: 'Керувати рахунками та підписками',
  buyPermissionDeniedTip: 'Зв\'яжіться з адміністратором вашого підприємства, щоб оформити підписку',
  plansCommon: {
    title: 'Виберіть план, який підходить саме вам',
    yearlyTip: 'Отримайте 2 місяці безкоштовно, оформивши річну підписку!',
    mostPopular: 'Найпопулярніший',
    planRange: {
      monthly: 'Щомісяця',
      yearly: 'Щорічно',
    },
    month: 'місяць',
    year: 'рік',
    save: 'Зберегти ',
    free: 'Безкоштовно',
    currentPlan: 'Поточний план',
    contractSales: 'Зв\'язатися з відділом продажів',
    contractOwner: 'Зв\'язатися з керівником команди',
    startForFree: 'Почніть безкоштовно',
    getStartedWith: 'Почніть роботу з ',
    contactSales: 'Зв\'язатися з відділом продажів',
    talkToSales: 'Поговоріть зі службою продажів',
    modelProviders: 'Постачальники моделей',
    teamMembers: 'Члени команди',
    buildApps: 'Створювати додатки',
    vectorSpace: 'Векторний простір',
    vectorSpaceBillingTooltip: 'Кожен 1 МБ може зберігати близько 1,2 мільйона символів векторизованих даних (оцінка з використанням OpenAI Embeddings, відрізняється в залежності від моделей).',
    vectorSpaceTooltip: 'Векторний простір – це система довгострокової пам\'яті, необхідна LLM для розуміння ваших даних.',
    documentProcessingPriority: 'Пріоритет обробки документів',
    documentProcessingPriorityTip: 'Для вищого пріоритету обробки документів оновіть свій план.',
    documentProcessingPriorityUpgrade: 'Обробляйте більше даних із вищою точністю та на більших швидкостях.',
    priority: {
      'standard': 'Стандартний',
      'priority': 'Пріоритетний',
      'top-priority': 'Найвищий пріоритет',
    },
    logsHistory: 'Історія журналів',
    customTools: 'Користувальницькі інструменти',
    unavailable: 'Недоступний',
    days: 'днів',
    unlimited: 'Безлімітний',
    support: 'Підтримка',
    supportItems: {
      communityForums: 'Форуми спільноти',
      emailSupport: 'Підтримка електронною поштою',
      priorityEmail: 'Пріоритетна підтримка електронною поштою та в чаті',
      logoChange: 'Зміна логотипу',
      SSOAuthentication: 'Автентифікація SSO',
      personalizedSupport: 'Персоналізована підтримка',
      dedicatedAPISupport: 'Спеціальна підтримка API',
      customIntegration: 'Вбудована інтеграція та підтримка',
      ragAPIRequest: 'RAG API запити',
      agentMode: 'Режим агента',
      workflow: 'Робочий процес',
      bulkUpload: 'Масове завантаження документів',
      llmLoadingBalancing: 'Балансування навантаження LLM',
      llmLoadingBalancingTooltip: 'Додавайте кілька ключів API до моделей, ефективно обходячи обмеження швидкості API.',
    },
    comingSoon: 'Скоро',
    member: 'Учасник',
    memberAfter: 'учасника',
    messageRequest: {
      title: 'Кредити повідомлень',
      tooltip: 'Квоти на виклик повідомлень для різних планів з використанням моделей OpenAI (крім gpt4). Повідомлення понад ліміт використовуватимуть ваш ключ API OpenAI.',
      titlePerMonth: '{{count,number}} повідомлень/місяць',
    },
    annotatedResponse: {
      title: 'Ліміти квоти відповідей з анотаціями',
      tooltip: 'Ручне редагування та анотування відповідей забезпечує налаштовувані високоякісні можливості відповідей на запитання для програм. (Застосовується лише в чат-програмах)',
    },
    ragAPIRequestTooltip: 'Відноситься до кількості викликів API, що викликають лише можливості обробки бази знань Dify.',
    receiptInfo: 'Лише власник команди та адміністратор команди можуть підписуватися та переглядати інформацію про виставлення рахунків',
    annotationQuota: 'Квота анотацій',
    documentsUploadQuota: 'Квота завантаження документів',
    teamMember_one: '{{count,number}} член команди',
    teamWorkspace: '{{count,number}} Командний Простір',
    apiRateLimit: 'Обмеження швидкості API',
    documentsTooltip: 'Квота на кількість документів, імпортованих з джерела знань.',
    self: 'Власний хостинг',
    cloud: 'Хмарний сервіс',
    documentsRequestQuota: '{{count,number}}/хвилина Ліміт запиту знань',
    annualBilling: 'Щорічна оплата',
    priceTip: 'за робочим простором/',
    unlimitedApiRate: 'Немає обмеження на швидкість API',
    freeTrialTipSuffix: 'Кредитна картка не потрібна',
    apiRateLimitUnit: '{{count,number}}/день',
    getStarted: 'Почати',
    freeTrialTip: 'безкоштовна пробна версія з 200 запитів до OpenAI.',
    documents: '{{count,number}} Документів знань',
    freeTrialTipPrefix: 'Зареєструйтесь і отримайте',
    teamMember_other: '{{count,number}} членів команди',
    comparePlanAndFeatures: 'Порівняйте плани та функції',
    apiRateLimitTooltip: 'Обмеження частоти запитів застосовується до всіх запитів, зроблених через API Dify, включаючи генерацію тексту, чат-розмови, виконання робочих процесів та обробку документів.',
    documentsRequestQuotaTooltip: 'Вказує загальну кількість дій, які робоча область може виконувати за хвилину в межах бази знань, включаючи створення, видалення, оновлення наборів даних, завантаження документів, модифікації, архівування та запити до бази знань. Цей показник використовується для оцінки ефективності запитів до бази знань. Наприклад, якщо користувач Sandbox виконує 10 послідовних тестів за один хвилину, його робочій області буде тимчасово заборонено виконувати наступні дії протягом наступної хвилини: створення наборів даних, видалення, оновлення, а також завантаження чи модифікацію документів.',
  },
  plans: {
    sandbox: {
      name: 'Пісочниця',
      description: '200 безкоштовних пробних версій GPT',
      includesTitle: 'Включає в себе:',
      for: 'Безкоштовна пробна версія основних функцій',
    },
    professional: {
      name: 'Професійний',
      description: 'Щоб окремі особи та невеликі команди могли отримати більше можливостей за доступною ціною.',
      includesTitle: 'Все у безкоштовному плані, плюс:',
      for: 'Для незалежних розробників/малих команд',
    },
    team: {
      name: 'Команда',
      description: 'Співпрацюйте без обмежень і користуйтеся продуктивністю найвищого рівня.',
      includesTitle: 'Все, що входить до плану Professional, плюс:',
      for: 'Для середніх команд',
    },
    enterprise: {
      name: 'Ентерпрайз',
      description: 'Отримайте повні можливості та підтримку для масштабних критично важливих систем.',
      includesTitle: 'Все, що входить до плану Team, плюс:',
      features: {
        5: 'Угоди про рівень обслуговування, узгоджені партнерами Dify',
        2: 'Ексклюзивні підприємницькі функції',
        6: 'Розвинена безпека та контроль',
        8: 'Професійна технічна підтримка',
        1: 'Комерційна ліцензія на авторизацію',
        3: 'Кілька робочих просторів та управління підприємством',
        4: 'ССО',
        0: 'Рішення для масштабованого розгортання підприємств',
        7: 'Оновлення та обслуговування від Dify Офіційно',
      },
      btnText: 'Зв\'язатися з відділом продажу',
      priceTip: 'Тільки річна оплата',
      for: 'Для великих команд',
      price: 'Користувацький',
    },
    community: {
      features: {
        2: 'Відповідає ліцензії Dify Open Source',
        1: 'Єдине робоче місце',
        0: 'Усі основні функції випущені під публічним репозиторієм',
      },
      btnText: 'Розпочніть з громади',
      includesTitle: 'Безкоштовні можливості:',
      for: 'Для індивідуальних користувачів, малих команд або некомерційних проектів',
      price: 'Безкоштовно',
      description: 'Для індивідуальних користувачів, малих команд або некомерційних проектів',
      name: 'Спільнота',
    },
    premium: {
      features: {
        2: 'Логотип веб-додатку та налаштування брендингу',
        1: 'Єдине робоче місце',
        3: 'Пріоритетна email та чат підтримка',
        0: 'Самостійно керовані надійність різних хмарних постачальників',
      },
      description: 'Для середніх підприємств та команд',
      btnText: 'Отримайте Преміум у',
      price: 'Масштабований',
      comingSoon: 'Підтримка Microsoft Azure та Google Cloud незабаром',
      priceTip: 'На основі Хмарного ринку',
      for: 'Для середніх підприємств та команд',
      name: 'Преміум',
      includesTitle: 'Все з громади, плюс:',
    },
  },
  vectorSpace: {
    fullTip: 'Векторний простір заповнений.',
    fullSolution: 'Оновіть свій план, щоб отримати більше місця.',
  },
  apps: {
    fullTipLine1: 'Оновіть свій план, щоб',
    fullTipLine2: 'створити більше програм.',
    fullTip1des: 'Ви досягли межі створення додатків за цим планом.',
    fullTip2: 'Досягнуто ліміту плану',
    fullTip1: 'Оновіть, щоб створити більше додатків',
    contactUs: 'Зв\'яжіться з нами',
    fullTip2des: 'Рекомендується очистити неактивні програми, щоб звільнити місце, або зв\'язатися з нами.',
  },
  annotatedResponse: {
    fullTipLine1: 'Оновіть свій план, щоб',
    fullTipLine2: 'анотувати більше розмов.',
    quotaTitle: 'Квота на анотовані відповіді',
  },
  usagePage: {
    teamMembers: 'Члени команди',
    buildApps: 'Створюйте додатки',
    annotationQuota: 'Квота анотацій',
    vectorSpaceTooltip: 'Документи з режимом індексування високої якості споживатимуть ресурси Сховища Знань. Коли Сховище Знань досягне межі, нові документи не будуть завантажені.',
    documentsUploadQuota: 'Квота на завантаження документів',
    vectorSpace: 'Сховище даних знань',
  },
  teamMembers: 'Члени команди',
}

export default translation
